import { render, staticRenderFns } from "./AccountRegist.vue?vue&type=template&id=2c689f79&"
import script from "./AccountRegist.vue?vue&type=script&lang=js&"
export * from "./AccountRegist.vue?vue&type=script&lang=js&"
import style0 from "./AccountRegist.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports